<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <form [formGroup]="form">
            <h1 class="font-bold text-xl">{{title}}</h1>
            <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
            @if(form.errors) {
            <div class="mt-2 w-full bg-red-200 border-l-2 border-l-red-500">
                <p class="text-primary-500 text-xs px-2 py-1">{{form.errors | json}}</p>
            </div>
            }
            <div class="mt-2 w-full">
                <label class="text-xs w-full mb-1" for="sessionName">Session Name</label>
                <input type="text" name="sessionName" id="sessionName" formControlName="sessionName"
                    placeholder="Session Name"
                    class="rounded w-full my-auto outline-none text-sm ring-0 focus:outline-none focus:ring-0">
                <div
                    class="{{ form.get('sessionName')?.invalid && (form.get('sessionName')?.dirty || form.get('sessionName')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-5 text-red-500 text-xs">
                    @if (form.get('sessionName')?.errors?.['required']) {
                    <p>
                        Value is required
                    </p>
                    } @else if(form.get('sessionName')?.errors?.['minlength'] ||
                    form.get('sessionName')?.errors?.['maxlength']) {
                    <p>
                        Min 3 and max 100 characters required
                    </p>
                    }
                </div>
            </div>
            <div class="flex flex-row gap-2 flex-nowrap w-full">
                <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs" for="startDate">Start Date</label>
                    <input type="date" name="startDate" id="startDate" formControlName="startDate"
                        placeholder="Start Date"
                        class="rounded w-full my-auto outline-none text-sm ring-0 focus:outline-none focus:ring-0 shadow">
                </div>
                <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs" for="startTime">Start Time</label>
                    <input type="time" name="startTime" id="startTime" formControlName="startTime"
                        placeholder="Start Time"
                        class="rounded w-full my-auto outline-none text-sm ring-0 focus:outline-none focus:ring-0 shadow">
                </div>
            </div>
            <div class="mt-4 flex flex-row gap-2 flex-nowrap w-full">
                <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs" for="endDate">End Date</label>
                    <input type="date" name="endDate" id="endDate" formControlName="endDate" placeholder="End Date"
                        class="rounded w-full my-auto outline-none text-sm ring-0 focus:outline-none focus:ring-0">
                </div>
                <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs" for="endTime">End Time</label>
                    <input type="time" name="endTime" id="endTime" formControlName="endTime" placeholder="End Time"
                        class="rounded w-full my-auto outline-none text-sm ring-0 focus:outline-none focus:ring-0">
                </div>
            </div>

            @if (isAssignable) {
            <div class="mt-4 w-full flex flex-col gap-1">
                <label class="text-xs">Assigned Teacher</label>
                <select (change)="onChangeOption($event)"
                    class="appearance-none placeholder-blueGray-300 bg-white rounded text-sm shadow focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                    @for (item of faculty$ | async; track item.memberId) {
                    <option [selected]="form.get('teacherId')?.value == item.memberId" [value]="item.memberId"
                        class="bg-white text-primary-500 text-sm">
                        {{item?.name}}</option>
                    }
                    <option [selected]="form.get('teacherId')?.value == 'unassigned'" value="unassigned"
                        class="bg-white text-primary-500 text-sm">
                        Unassigned</option>
                </select>
                <div class="{{ form.touched ? 'visible' : 'invisible'}} px-2 h-4 text-red-500 text-xs">
                    @if (form.get('teacherId')?.errors?.['required']) {
                    <p>
                        Value is required
                    </p>
                    }
                </div>
            </div>
            } @else {
            <div class="mt-4">{{isAssignable}}</div>
            }

            <div class="w-full flex flex-col gap-1">
                <label class="text-xs">Lesson</label>
                <select (change)="onChangeLesson($event)"
                    class="appearance-none placeholder-blueGray-300 bg-white rounded text-sm shadow focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                    @for (item of lessons$ | async; track item.id) {
                    <option [selected]="form.get('lessonId')?.value == item.id" [value]="item.id"
                        class="bg-white text-primary-500 text-sm">
                        {{item?.lessonName}}</option>
                    }
                    <option [selected]="form.get('lessonId')?.value == 'unassigned'" value="unassigned"
                        class="bg-white text-primary-500 text-sm">
                        Unassigned</option>
                </select>
            </div>

            <div class="mt-4 flex flex-row gap-4 justify-end">
                <button type="button" (click)="onCancel()"
                    class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
                <app-btn-action [inProgress]="(working$ | async) ?? false" (clicked)="submit()" [label]="action"
                    bgColor="bg-primary-500 hover:bg-primary-400 active:bg-secondary-500"></app-btn-action>
            </div>
        </form>
    </div>
</div>